<template>
  <div>

  </div>
</template>

<script>
  import api from "../../api/api-list"
  import global from "../../api/api-list/global";
  export default {
    name: "PayType",
    mounted() {
      console.log(process.env.VUE_APP_WECHAT_APP_ID,process.env.VUE_APP_HOST)
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
      if (typeof AlipayJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', this.onAiReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', this.onAiReady);
        }
      } else {
        this.onAiReady();
      }
    },
    methods: {
      //微信支付
      onBridgeReady() {
        let appid = process.env.VUE_APP_WECHAT_APP_ID
        let redirect_uri = `${process.env.VUE_APP_HOST}/pay/wechat`
        let query = JSON.stringify(this.$route.query || {})
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${query}#wechat_redirect`
      },
      //阿里流程
      async onAiReady() {
        let { orderId, coupon_id, type, repurchase_discount } = this.$route.query
        let res = null

        // c端 导师支付
        if(type === 'mentor'){
          res = await api.global.mentorOrderPay(orderId, {pay_type: 'alipay',coupon_id})
        // c端 会员支付
        } else if(type === 'member'){
          res = await api.global.orderPay(orderId, {pay_type: 'alipay',coupon_id, repurchase_discount: !repurchase_discount || repurchase_discount === '0' ? 0 : 1})
        // b端 职位置顶 和 发布火爆职位 ，火爆职位和职位置顶 ,购买查看电话次数
        } else if (type === 'bJobHot' || type === 'bJobTop' || type === 'bHotAndTop' || type === 'bPhone' || type === 'bJobRefresh') {
          // let tempres = await api.global.updateOrderStatus({order_token: orderId})
          // if(tempres.code !== 1000) {
          //   alert(JSON.stringify(res))
          //   return
          // }
          res = await api.global.bJobOrderPay(orderId, {pay_type: 'alipay',coupon_id})
        // c端 照片美颜
        } else if (type === 'cPhotoBeauty') {
          res = await api.global.orderPay(orderId, {pay_type: 'alipay',coupon_id})
        }
        let {code, data} = res
        if(code == 1000){
          let {result} = data
          window.location.href = result
        }else{
          alert(JSON.stringify(res))
        }

      }
    }
  }
</script>

<style scoped>
  #udesk_btn {
    display: none;
  }
</style>
